import React, { Component } from "react";
import PropTypes from "prop-types";
import { Header, SideBar } from "../common";
import { SIDEBAR_MENU_ITEMS } from "../../shared/constants/fieldTypes";
import { isMobileDevice } from "../../helpers/Utils";

class Layout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      screenHeight: "",
    };
  }

  componentDidMount() {
    this.setState({ screenHeight: global.innerHeight });
  }

  render() {
    const { screenHeight } = this.state;
    const { children, hideHeader, selectedItem } = this.props;
    const searchParams = new URLSearchParams(window.location.search);
    const forceRemoveHeader = searchParams.get("force_hide_header") === "true";
    if (
      window.location.pathname === "/" ||
      window.location.pathname.includes("/external_fee_payment/")
    ) {
      return <div>{children}</div>;
    }
    return (
      <div
        style={{
          backgroundColor: "#FCFCFC",
          minHeight: screenHeight,
          maxWidth: "100%",
          overflowX: "hidden",
          paddingTop: forceRemoveHeader ? 15 : 0,
        }}
      >
        {!forceRemoveHeader && !hideHeader && (
          <Header selectedItem={selectedItem} />
        )}
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <SideBar
            menuList={SIDEBAR_MENU_ITEMS}
            selectedOption={window.location.pathname}
          />
          <div
            style={{
              marginTop: 70,
              width: isMobileDevice() ? "100vw" : "84vw",
            }}
          >
            {children}
          </div>
        </div>
      </div>
    );
  }
}

Layout.propTypes = {
  hideHeader: PropTypes.bool,
  hideFooter: PropTypes.bool,
};

Layout.defaultProps = {
  hideHeader: false,
  hideFooter: false,
};

export default Layout;
